module.exports = __webpack_public_path__ + "img/Flottenmanagement_UI.246c63ef.png";